import { DateTimeHelper } from '@/helper/dateTime'

const EXPECTED_ROLES = ['artice', 'web', 'mobile']

export class SubscriberRole {
  exp: number
  role: string

  constructor(exp: number, role: string) {
    this.exp = exp
    this.role = role
  }
}

export class JwtToken {
  aud = ''
  sub = 0
  sbr: Array<SubscriberRole> = []
  subscriber?: boolean

  static fromObject(obj: Record<string, any>): JwtToken {
    const jwtToken = new JwtToken()

    if (Object.prototype.hasOwnProperty.call(obj, 'aud')) {
      jwtToken.aud = obj.aud
    }
    if (Object.prototype.hasOwnProperty.call(obj, 'sub')) {
      jwtToken.sub = parseInt(obj.sub)
    }
    if (Object.prototype.hasOwnProperty.call(obj, 'sbr')) {
      if (typeof obj.sbr === 'object') {
        for (const [key, value] of Object.entries<any>(obj.sbr)) {
          if (Object.prototype.hasOwnProperty.call(value, 'exp')) {
            jwtToken.sbr.push(new SubscriberRole(parseInt(value.exp), key))
          }
        }
      }
    }

    return jwtToken
  }

  isSubscriber(): boolean {
    if (typeof this.subscriber === 'undefined') {
      const timestamp = DateTimeHelper.getCurrentTimestamp()

      const roles = this.sbr.filter(
        (role: SubscriberRole) =>
          EXPECTED_ROLES.includes(role.role) && role.exp > timestamp
      )

      this.subscriber = roles.length > 0
    }

    return this.subscriber
  }
}
